import React, { useEffect, useState } from "react";
import LogoMain from "../../assets/images/logo-main.png";
import { data } from "./faqs_data";
import { FiArrowLeft } from "react-icons/fi";
import customHistory from "../../components/RouteHistory";
import { RouteNames } from "../../constants";

interface SearchbarProps {
  onSearchChange: (val: string) => void;
}

const Searchbar = ({ onSearchChange }: SearchbarProps) => {
  const [value, setValue] = useState("");
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setValue(e.target.value);
    onSearchChange(e.target.value);
  };
  return (
    <form>
      <svg viewBox="0 0 512 512" width="100">
        <path d="M505 442.7L405.3 343c-4.5-4.5-10.6-7-17-7H372c27.6-35.3 44-79.7 44-128C416 93.1 322.9 0 208 0S0 93.1 0 208s93.1 208 208 208c48.3 0 92.7-16.4 128-44v16.3c0 6.4 2.5 12.5 7 17l99.7 99.7c9.4 9.4 24.6 9.4 33.9 0l28.3-28.3c9.4-9.4 9.4-24.6.1-34zM208 336c-70.7 0-128-57.2-128-128 0-70.7 57.2-128 128-128 70.7 0 128 57.2 128 128 0 70.7-57.2 128-128 128z" />
      </svg>
      <input
        className="searchbar"
        type="text"
        placeholder="Search FAQs"
        value={value}
        onChange={handleChange}
      />
    </form>
  );
};

interface QuestionProps {
  id: number;
  head: string;
  text: string;
}

const Accordion = ({ id, head, text }: QuestionProps) => {
  const [isActive, setActive] = useState(false);
  const handleClick = () => {
    setActive(!isActive);
  };

  return (
    // <ClickAwayListener onClickAway={}></ClickAwayListener>
    <div className="question-wrapper">
      <div className="question" id={`${id}`} onClick={handleClick}>
        <h3 className="text-left">{head}</h3>
        <svg
          className={isActive ? "active" : ""}
          viewBox="0 0 320 512"
          width="100"
        >
          <path d="M143 352.3L7 216.3c-9.4-9.4-9.4-24.6 0-33.9l22.6-22.6c9.4-9.4 24.6-9.4 33.9 0l96.4 96.4 96.4-96.4c9.4-9.4 24.6-9.4 33.9 0l22.6 22.6c9.4 9.4 9.4 24.6 0 33.9l-136 136c-9.2 9.4-24.4 9.4-33.8 0z" />
        </svg>
      </div>
      <div className={isActive ? "answer active" : "answer"}>
        <div dangerouslySetInnerHTML={{ __html: text }} />
      </div>
    </div>
  );
};

const FAQsPage = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [searchResults, setSearchResults] = useState(data);

  const handleSearchChange = (searchValue: string) => {
    setSearchTerm(searchValue);
  };

  useEffect(() => {
    let res: Array<any> = [];
    data.forEach((item) => {
      const itemResult = item.faqs.filter((faq) =>
        faq.question.toLowerCase().includes(searchTerm)
      );
      if (itemResult.length > 0) {
        res.push({
          name: item.name,
          faqs: itemResult,
        });
      }
    });
    setSearchResults(res);
  }, [searchTerm]);

  return (
    <div className="faqs-page">
      <div className="sidebar-logo">
        <img
          src={LogoMain}
          alt=""
          style={{
            width: "100px",
          }}
        />
      </div>
      <div>
        <div className="flex text-primary mb-4">
          {/* @ts-ignore*/}
          <button
            className="btn btn-outline font-semibold mr-4"
            onClick={() => customHistory.push(RouteNames.DASHBOARD)}
          >
            <FiArrowLeft className="mr-1 text-xl" />
            Back
          </button>
        </div>
      </div>
      <h2 className="heading text-center">Frequently Asked Questions</h2>
      <div className="containerr">
        <h2 className="heading">
          <Searchbar onSearchChange={handleSearchChange} />
        </h2>
        <section className="faqs">
          {searchResults.map((data, index) => (
            <div className="faq-group" key={index}>
              <div className="faq-group-head">{data.name}</div>
              <div className="faq-group-items">
                {data.faqs.map((item) => (
                  <Accordion
                    head={item.question}
                    text={item.answer}
                    id={item.id}
                    key={item.id}
                  />
                ))}
              </div>
            </div>
          ))}
        </section>
      </div>
    </div>
  );
};

export default FAQsPage;
